import { mercuryApi } from '$api'
import { AccountingSystem, AuthModule, PayrollSystem } from '$constants'
import { ThirdPartyConnectionStatus } from '$models'
import { exceptionMessageHandler } from '$utils'
import { StateCreator } from 'zustand'

interface SharedState {
  isLoading: boolean
}

export interface SharedSlice extends SharedState {
  setIsLoading: (newData: boolean) => void

  /**
   * Resets Shared Slice state
   */
  resetSharedSlice: () => void

  /**
   * Check Xero connection
   * @param authModule Time or Stock
   * @returns
   */
  checkExternalSystemConnection: (
    authModule: AuthModule,
    system: AccountingSystem
  ) => Promise<ThirdPartyConnectionStatus | null>
}

const initialState: SharedState = {
  isLoading: false,
}

export const createSharedSlice: StateCreator<
  SharedSlice,
  [],
  [],
  SharedSlice
> = (set) => ({
  // State variables
  ...initialState,

  // State setters
  setIsLoading: (newData) => set({ isLoading: newData }),
  resetSharedSlice: () => set(initialState),

  checkExternalSystemConnection: async (
    authModule: AuthModule,
    system: AccountingSystem | PayrollSystem
  ): Promise<ThirdPartyConnectionStatus | null> => {
    return mercuryApi
      .get<ThirdPartyConnectionStatus>(
        `/connections/${system}/status?module=${authModule}`
      )
      .catch((error) => {
        exceptionMessageHandler(
          error,
          `Failed to check connection with ${system}`
        )
        return null
      })
  },
})
